// Щ6 — таблиците на С14, без заглавието и без тегленето на данни.
//
// Изнесени са, защото същите таблици се показват на две места: справката зад
// вход (ReportS14) и публичния линк. Едно копие значи, че „отпаднал"/„нов"
// изглеждат еднакво и на двете места.

// Разликата се чете по знак и по цвят: плюс значи повече изчертано тази година.
// Нулата остава без цвят, за да не шуми редът.
const знак = (v) => (v > 0.005 ? '+' : '') + Number(v).toFixed(2);
const цвят = (v) => (v > 0.005 ? 'text-success' : v < -0.005 ? 'text-danger' : undefined);

// Щ6: масив само в едната година се обявява с ДУМА. Числото остава до нея —
// „отпаднал" без стойност не казва колко е било.
const Разлика = ({row}) => {
    if (row.status === 'dropped') {
        return (
            <span className="fw-bold text-danger">
                отпаднал{' '}
                <span className="fw-normal" style={{fontSize: "0.85em"}}>
                    ({знак(row.difference)})
                </span>
            </span>
        );
    }
    if (row.status === 'new') {
        return (
            <span className="fw-bold text-success">
                нов{' '}
                <span className="fw-normal" style={{fontSize: "0.85em"}}>
                    ({знак(row.difference)})
                </span>
            </span>
        );
    }
    return <span className={`fw-bold ${цвят(row.difference) || ''}`}>{знак(row.difference)}</span>;
};

// Всички таблици тук са РАЗЛИЧНИ таблици (по една на землище + общата отдолу).
// Без изрични ширини всяка си мери колоните сама и общият ред застава разкрачен
// спрямо секциите над него.
const колони = (
    <colgroup>
        <col style={{width: "22%"}}/>
        <col style={{width: "24%"}}/>
        <col style={{width: "24%"}}/>
        <col style={{width: "30%"}}/>
    </colgroup>
);

export const S14View = ({data}) => {
    const празна = data.sections.length === 0;

    if (празна) {
        return (
            <div className="alert alert-info">
                Няма изчертани площи нито за {data.previous_year}, нито за {data.year} година.
            </div>
        );
    }

    return (
        <>
            {data.sections.map(section => (
                <div key={section.settlement_ekatte} className="mb-4">
                    <h6 style={{color: "var(--app-gold)"}}>{section.settlement_name}</h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered" style={{tableLayout: "fixed"}}>
                            {колони}
                            <thead className="tableHead">
                            <tr>
                                <th>Масив</th>
                                <th className="text-end">Стопанска {data.previous_year} (дка)</th>
                                <th className="text-end">Стопанска {data.year} (дка)</th>
                                <th className="text-end">Разлика (дка)</th>
                            </tr>
                            </thead>
                            <tbody>
                            {section.rows.map((row, i) => (
                                <tr key={i}>
                                    <td>{row.massif_number}</td>
                                    <td className="text-end">{row.previous.toFixed(2)}</td>
                                    <td className="text-end">{row.current.toFixed(2)}</td>
                                    <td className="text-end"><Разлика row={row}/></td>
                                </tr>
                            ))}
                            </tbody>
                            <tfoot>
                            <tr className="fw-bold">
                                <td>Общо</td>
                                <td className="text-end">{section.subtotal_previous.toFixed(2)}</td>
                                <td className="text-end">{section.subtotal_current.toFixed(2)}</td>
                                <td className={`text-end ${цвят(section.subtotal_difference) || ''}`}>
                                    {знак(section.subtotal_difference)}
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            ))}

            {/* При едно землище общият ред само би повторил междинния. */}
            {data.sections.length > 1 && (
                <div className="table-responsive">
                    <table className="table table-sm table-bordered" style={{tableLayout: "fixed"}}>
                        {колони}
                        <tbody>
                        <tr className="fw-bold">
                            <td>ОБЩО</td>
                            <td className="text-end">{data.total_previous.toFixed(2)}</td>
                            <td className="text-end">{data.total_current.toFixed(2)}</td>
                            <td className={`text-end ${цвят(data.total_difference) || ''}`}>
                                {знак(data.total_difference)}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            )}

            <div className="text-muted mt-2" style={{fontSize: "0.9rem"}}>
                Редът е един масив; МПО номерата вътре в него се сумират, защото се
                преномерират между годините. Масив, който го има само в едната година,
                е отбелязан като <span className="text-success fw-bold">нов</span> или{" "}
                <span className="text-danger fw-bold">отпаднал</span>. Разликата е текущата
                минус предходната година.
            </div>
        </>
    );
};
